import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateRegionDeliveryRangeSettingEntity } from '../../domain/entities/CreateUpdateRegionDeliveryRangeSettingEntity'

export class CreateUpdateRegionDeliveryRangeSettingModel extends CreateUpdateRegionDeliveryRangeSettingEntity {
  regionId!: number
  constructor(dataDto: CreateUpdateRegionDeliveryRangeSettingEntity) {
    super()
    mapEntityProperties<CreateUpdateRegionDeliveryRangeSettingModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id
      }
    })
  }
}
